import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=3feec102&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=3feec102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feec102",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3feec102')) {
      api.createRecord('3feec102', component.options)
    } else {
      api.reload('3feec102', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=3feec102&scoped=true&", function () {
      api.rerender('3feec102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j3aZpr5hgMl3/JS/comp/DocBox.vue"
export default component.exports